import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

const benefits = [
  '본인 통장으로 정산, 수수료 투명',
  '간편한 판매자 등록 심사',
  '판매 데이터 실시간 분석',
];

export default function SellerCta() {
  return (
    <section id="sell" className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-background-200 border border-background-300 px-6 py-12 md:px-14 md:py-16">
          <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-primary-500/20 blur-3xl" />
          <div className="absolute -bottom-20 left-1/4 w-72 h-72 rounded-full bg-accent-500/15 blur-3xl" />
          <div className="absolute inset-0 tech-grid tech-grid-mask opacity-40 pointer-events-none" />

          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-xl">
              <h2 className="font-display text-3xl md:text-4xl font-normal tracking-tight text-white leading-tight">
                당신의 디지털 상품을
                <br />
                팔아보세요
              </h2>
              <p className="mt-4 text-foreground-400 leading-relaxed">
                판매자로 등록하면 누구나 쉽게 상품을 등록하고 수익을 얻을 수 있습니다.
              </p>
              <ul className="mt-6 space-y-3">
                {benefits.map((b) => (
                  <li key={b} className="flex items-center gap-3 text-foreground-200">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-sm">{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-3 w-full lg:w-auto">
              <Link
                to="/sell"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-foreground-950 font-semibold hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer shine"
              >
                판매자로 시작하기
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
              <span className="text-xs text-foreground-500 text-center lg:text-right">
                판매자 등록은 무료입니다
              </span>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}